import * as React from "react";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import getArticleService from "../../../services/getArticleService";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const getPaymentStatus = (article) => {
  if (!article.paymentStatus) {
    return { status: "unpaid", label: "Unpaid", color: "error" };
  }

  if (!article.payments || article.payments.length === 0) {
    return { status: "unpaid", label: "Unpaid", color: "error" };
  }

  // Check if all payments have UTR numbers
  const allPaymentsHaveUTR = article.payments.every(
    (payment) => payment.utrNo && payment.utrNo.trim() !== ""
  );

  if (allPaymentsHaveUTR) {
    return {
      status: "confirmed_payment",
      label: "Confirmed Payment",
      color: "success",
    };
  } else {
    return {
      status: "unconfirmed_payment",
      label: "Unconfirmed Payment",
      color: "warning",
    };
  }
};

const PaymentVerify = ({
  openViewImage,
  handleCloseViewImage,
  selectedRow,
  handleVerifyPayment,
}) => {
  const fileUrl = process.env.REACT_APP_API_URL;
  const [preSignedUrl, setPreSignedUrl] = React.useState(null);
  const paymentStatus = getPaymentStatus(selectedRow);

  const fetchData = async () => {
    const filterVal = {
      key: selectedRow?.paymentProof,
    };
    try {
      const data = await getArticleService.getFilePreSIgnedUrl(filterVal);
      setPreSignedUrl(data);
      console.log(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  React.useEffect(() => {
    if (selectedRow?.paymentProof) {
      fetchData();
    }
  }, [selectedRow?.paymentProof]);
  return (
    <React.Fragment>
      <Dialog
        open={openViewImage}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseViewImage}
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"md"}
      >
        <DialogTitle className="modal_header_dealog">{"Image"}</DialogTitle>
        <DialogContent>
          <div>
            <img src={preSignedUrl} alt="Image" className="img-fluid" />
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseViewImage}
            variant="outlined"
            color="error"
          >
            Close
          </Button>
          {paymentStatus.status === "unpaid" ? (
            <Button
              onClick={handleVerifyPayment}
              variant="outlined"
              color="error"
            >
              Unpaid
            </Button>
          ) : paymentStatus.status === "confirmed_payment" ? (
            <Button
              onClick={handleVerifyPayment}
              variant="outlined"
              color="success"
            >
             Confirmed Payment
            </Button>
          ) : (
            <Button
              onClick={handleVerifyPayment}
              variant="outlined"
              color="warning"
            >
              Unconfirmed Payment
            </Button>
          )}
       
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default PaymentVerify;
